import { render, staticRenderFns } from "./Jxlc.vue?vue&type=template&id=2698fd12&scoped=true"
import script from "./Jxlc.vue?vue&type=script&lang=js"
export * from "./Jxlc.vue?vue&type=script&lang=js"
import style0 from "./Jxlc.vue?vue&type=style&index=0&id=2698fd12&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2698fd12",
  null
  
)

export default component.exports